import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue"

import { RouterView } from 'vue-router';
import { computed, defineAsyncComponent } from 'vue';
import { useLayout } from '@/composables/useLayout';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { layout } = useLayout();
const layoutComponent = computed(() => layout.value ? defineAsyncComponent(() => import(`@/layouts/${layout.value}.vue`)) : '');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(layoutComponent.value), null, {
    default: _withCtx(() => [
      _createVNode(_unref(RouterView), null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            "enter-active-class": "transition ease-out duration-300",
            "enter-from-class": "opacity-0 transform -translate-y-5",
            "enter-to-class": "opacity-100 transform translate-y-0",
            "leave-active-class": "transition ease-in duration-300",
            "leave-from-class": "opacity-100 transform translate-y-0",
            "leave-to-class": "opacity-0 transform -translate-y-5"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: "routerViewSlot" }))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})